export const ENDPOINT_ROOT = {
    area: 'areas',
    view: 'views',
    camera: 'camera',
    category: 'category',
    customer: 'customers',
    dashboardLayout: 'dashboard/layouts',
    dashboardLayoutByViewId: '/dashboard/settings/campaigns',
    dataInsight: 'dataInsight',
    event: 'event',
    externalSource: 'externalSource',
    groupView: 'groupCampaign',
    headcounter: 'headcounters',
    headcounterSensor: 'headcounters/sensors',
    headcounterSensorBucket: 'headcounters/sensors/createBucket',
    headcounterSensorRecall: 'recallHeadcountersensor',
    headcounterGetLogger: 'headcounters/sensors/log',
    hierarchicalCategory: 'hierarchicalcategory',
    history: 'tracking',
    industry: 'industry',
    location: 'location',
    overview: 'overview',
    pom: 'poms',
    province: 'province',
    permission: 'permission',
    region: 'region',
    registration: 'registration',
    report: 'reports',
    softwareVersion: 'headcounters/software/versions',
    summaryReport: 'summaryReports',
    tag: 'tag',
    ticketing: 'ticketing',
    trends: 'trends',
    user: 'users',
    userUnblock: 'users/unblock',
    usergroup: 'usergroup',
    userGetByMultipleId: 'users/getByMultipleId',
    userAddToView: 'users/addToView',
    userRemoveFromView: 'users/removeFromView',

    userForgotPassword: 'users/forgotPassword',
    userResetPassword: 'users/forgotPassword/reset',
    impersonation: 'impersonation'
}